import React, { createContext, useEffect, useRef, useState } from "react";
import { CONTACT_CODE } from "./ContactCode";
import {
	ContactAllImg,
	ContactAllInner,
	ContactAllInnerImg,
	ContactAllInnerName,
	ContactAllOnClick,
	ContactQuickCallImg,
	ContactQuickCallLink,
	ContactAllRef,
	ContactAllWrap,
} from "./ContactAllStyled";

export const HomeContext = createContext<{
	openDetailDialog: boolean;

	loading: boolean;
	loadMore: () => void;
	isInitLoading: boolean;
	isValidated: boolean | undefined;
} | null>(null);

export default function ContactAll() {
	const [isOpen, setIsOpen] = useState(false);
	const phoneContact = CONTACT_CODE.find((item) => item.link.startsWith("tel:"));

	const toggleDropdown = () => setIsOpen(!isOpen);

	const dropdownRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [dropdownRef]);

	return (
		<ContactAllWrap ref={dropdownRef}>
			{phoneContact ? (
				<ContactQuickCallLink
					href={phoneContact.link}
					aria-label="Call WhaleLO support"
					title="Call WhaleLO support">
					<ContactQuickCallImg
						src={phoneContact.image}
						alt={phoneContact.name}
					/>
				</ContactQuickCallLink>
			) : null}
			{isOpen && (
				<ContactAllRef>
					{CONTACT_CODE.map((val) => (
						<ContactAllInner
							key={val.code}
							onClick={() => window.open(val.link, "_blank", "noopener,noreferrer")}>
							<ContactAllInnerImg
								src={val.image}
								alt={val.name}
							/>
							<ContactAllInnerName>{val.name}</ContactAllInnerName>
						</ContactAllInner>
					))}
				</ContactAllRef>
			)}
			<ContactAllOnClick onClick={toggleDropdown}>
				<ContactAllImg src="./static/img/chat-bubble.png" />
			</ContactAllOnClick>
		</ContactAllWrap>
	);
}
